import { toQueryParams } from '@shared/utils/url';
import { v1, v2 } from '@/api/client';
import type {
  AlarmData,
  AlarmDto,
  AlarmSeverity,
  AlarmStatus,
} from './api.types';
import { alarmDataSchema, alarmDtoSchema } from './api-schema';
import type {
  CreateSignalIntervalDto,
  SignalDefinitionDto,
  SignalIntervalDto,
  SignalIntervalTemplateDto,
  UpdateSignalIntervalDto,
  UpdateSignalIntervalsDto,
} from './api-signal-interval.types.d';

export const fetchAlarm = (alarmId: string) =>
  v1.get<AlarmDto>(`alarm/${alarmId}`, { schema: alarmDtoSchema });

export type FetchAlarmsOptions = {
  equipment_ids: string[];
  status?: AlarmStatus | AlarmStatus[];
  start_time?: Date;
  end_time?: Date;
  severity?: AlarmSeverity;
  alarm_type?: string;
  ignore_no_permit?: boolean;
  page?: number;
  size?: number;
};

export const fetchAlarms = (queryParams: FetchAlarmsOptions) =>
  v1.get<AlarmData>('alarm', {
    schema: alarmDataSchema,
    queryParams,
  });

export const fetchSignalIntervals = (equipmentId: string) =>
  v1.get<SignalIntervalDto[]>(
    `signal/interval${toQueryParams({ equipmentId })}`
  );

export const fetchSignalDefinitions = () =>
  v1.get<SignalDefinitionDto[]>('signal/definition');

export const createSignalInterval = (intervals: CreateSignalIntervalDto[]) => {
  if (intervals.length === 0) {
    return Promise.resolve(undefined);
  }
  return v2.post<SignalIntervalDto>('signal/interval', intervals);
};

export interface UpdateSignalIntervalOptions {
  id: string;
  data: UpdateSignalIntervalDto;
}

export const updateSignalInterval = ({
  id,
  data,
}: UpdateSignalIntervalOptions) =>
  v1.put<SignalIntervalDto>(`signal/interval/${id}`, data);

export const updateSignalIntervals = (
  intervals: UpdateSignalIntervalsDto[]
) => {
  if (intervals.length === 0) {
    return Promise.resolve();
  }

  return v1.put<void>(`signal/interval`, intervals, {
    responseType: 'void',
  });
};

export const fetchSignalIntervalTemplates = (equipmentId: string) =>
  v1.get<SignalIntervalTemplateDto[]>(
    `signal/interval/template${toQueryParams({ equipmentId })}`
  );
